var e=Object.freeze({default:.25,large:.3,medium:.25,small:.15}),l=Object.freeze({default:4,large:6,medium:4,small:2});export{e as SPINNER_ICON_BORDER_SIZES_MAP_IN_REM,l as SPINNER_ICON_SIZES_IN_REM};
//# sourceMappingURL=Spinner.constants.js.map
